export const LIST_DIVISION = 'src/Admin/Corporate/usage-stats/usage-stats-dashboard/LIST_DIVISION';
export const LIST_DIVISION_SUCCESS = 'src/components/Corporate/Create/action/LIST_DIVISION_SUCCESS';
export const LIST_DIVISION_FAILURE = 'src/components/Corporate/Create/action/LIST_DIVISION_FAILURE';
export const LIST_USER = 'src/Admin/Corporate/usage-stats/usage-stats-dashboard/LIST_USER';
export const LIST_USER_SUCCESS = 'src/components/Corporate/Create/action/LIST_USER_SUCCESS';
export const LIST_USER_FAILURE = 'src/components/Corporate/Create/action/LIST_USER_FAILURE';

export const listDivision = (data) => {
    return {
        type: LIST_DIVISION,
        data
    }
}

export const listDivisionSuccess = (data) => {
    return {
        type: LIST_DIVISION_SUCCESS,
        data
    }
}

export const listDivisionFailure = (error) => {
    return {
        type: LIST_DIVISION_FAILURE,
        error
    }
}

export const listUser = (data) => {
    return {
        type: LIST_USER,
        data
    }
}

export const listUserSuccess = (data) => {
    return {
        type: LIST_USER_SUCCESS,
        data
    }
}

export const listUserFailure = (error) => {
    return {
        type: LIST_USER_FAILURE,
        error
    }
}